import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    name: { type: String, default: "limit" },
    selector: String
  }

  sync(event) {
    const changed = event?.target
    if (!changed) return

    const fieldName = this.nameValue || changed.name
    if (changed.name !== fieldName) return

    const selector = this.hasSelectorValue && this.selectorValue
      ? this.selectorValue
      : `[name="${fieldName.replace(/"/g, '\\"')}"]`

    this.element.querySelectorAll(selector).forEach((field) => {
      if (field !== changed) field.value = changed.value
    })
  }
}
